import React, { useState, useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import { useAuth } from '../../shared/context/AuthContext';

export default function ModalTransferir({ analise, onClose, onSuccess }) {
  const { 
    setores, 
    carregarSetores,
    carregarColaboradoresPorSetor, 
    transferirAnalise 
  } = useControleDemanda();
  
  const { user } = useAuth();
  const [setorSelecionado, setSetorSelecionado] = useState('');
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState('');
  const [colaboradores, setColaboradores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSetores, setLoadingSetores] = useState(false);

  // Carregar setores quando o modal abre
  useEffect(() => {
    carregarSetoresModal();
  }, []);

  useEffect(() => {
    if (setorSelecionado) {
      carregarColaboradores();
    } else {
      setColaboradores([]);
      setColaboradorSelecionado('');
    }
  }, [setorSelecionado]);

  const carregarSetoresModal = async () => {
    setLoadingSetores(true);
    try {
      await carregarSetores();
    } catch (error) {
      console.error('Erro ao carregar setores no modal:', error);
    } finally {
      setLoadingSetores(false);
    }
  };

  const carregarColaboradores = async () => {
    setLoading(true);
    try {
      const colaboradoresData = await carregarColaboradoresPorSetor(setorSelecionado);
      setColaboradores(colaboradoresData);
    } catch (error) {
      console.error('Erro ao carregar colaboradores:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!setorSelecionado || !colaboradorSelecionado) {
      alert('Por favor, selecione o setor e o colaborador.');
      return;
    }

    setLoading(true);
    try {
      await transferirAnalise(
        analise.analisedemanda_id, 
        parseInt(setorSelecionado), 
        parseInt(colaboradorSelecionado), 
        user.id
      );
      onSuccess();
    } catch (error) {
      console.error('Erro ao transferir análise:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-transferir">
        <div className="modal-header">
          <h3>Transferir Análise</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="analise-info">
            <h4>Análise - Demanda #{analise.demanda_id}</h4>
            <p><strong>Setor Atual:</strong> {analise.analisedemanda_setor_descricao}</p>
            <p><strong>Funcionário Atual:</strong> {analise.analisedemanda_funcionario_envolvido_nome}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="setor">Novo Setor *</label>
              <select
                id="setor"
                value={setorSelecionado}
                onChange={(e) => setSetorSelecionado(e.target.value)}
                className="form-control"
                required
                disabled={loadingSetores}
              >
                <option value="">
                  {loadingSetores ? 'Carregando setores...' : 'Selecione um setor'}
                </option>
                {setores.filter(s => s.id !== analise.setor).map(setor => (
                  <option key={setor.id} value={setor.id}>
                    {setor.descricao}
                  </option>
                ))}
              </select>
              {loadingSetores && (
                <div className="form-text">
                  <i className="fas fa-spinner fa-spin"></i> Carregando setores disponíveis...
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="colaborador">Novo Colaborador Responsável *</label>
              <select
                id="colaborador"
                value={colaboradorSelecionado}
                onChange={(e) => setColaboradorSelecionado(e.target.value)}
                className="form-control"
                required
                disabled={!setorSelecionado || loading}
              >
                <option value="">
                  {loading ? 'Carregando...' : 'Selecione um colaborador'}
                </option>
                {colaboradores.map(colaborador => (
                  <option key={colaborador.id} value={colaborador.id}>
                    {colaborador.nome} - {colaborador.email}
                  </option>
                ))}
              </select>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || !setorSelecionado || !colaboradorSelecionado}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Transferindo...
                  </>
                ) : (
                  <>
                    <i className="fas fa-exchange-alt"></i>
                    Transferir
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}